export default __webpack_public_path__ + "static/media/wiriting.0869b4f9.jpg";